module.exports = __webpack_public_path__ + "static/media/login-web-bg.5a4c3a58.jpg";